if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    async onSubmitHandler(evt) {
    // onSubmitHandler(evt) {
      evt.preventDefault();

      //AK custom code
      const mounting_main = document.querySelector('.cstm_mounting_type_op');
      const mounting_type_error = document.querySelector('.cstm_mounting_type_op .cstm_errors');
      let main_pro_property;
      let main_pro_property_name;
      let mounting_pro_var_id;
      if(mounting_main){
       
        const mounting_radioes = document.querySelector('.cstm_mounting_type_op input[type="radio"]:checked');
        // console.log('mounting_radioes',mounting_radioes.length)
        if(mounting_radioes){

          main_pro_property_name = mounting_radioes.getAttribute('name');
          main_pro_property = mounting_radioes.value;
          mounting_type_error.classList.add('hidden');

          if(!mounting_radioes.classList.contains('mounting_default_op')){
            mounting_pro_var_id = mounting_radioes.getAttribute('data-var-id');
          }
        }else{
          if(mounting_type_error){
            mounting_type_error.classList.remove('hidden');
          }
          return;
        }
      }
      //End Ak custom code
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const timestamp = Date.now();
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      // 👉 ak custom code
      if (main_pro_property && main_pro_property_name) {
        formData.append(`properties[${main_pro_property_name}]`, main_pro_property);
      }
      

      if (mounting_pro_var_id) {
        if(timestamp){
           formData.append("properties[_timestamp]", timestamp);
           formData.append("properties[_main_product]", 'yes');
        }

        try {
          const freeAddResp = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                quantity: parseInt(this.form.querySelector('[name="quantity"]').value) || 1,
                id: mounting_pro_var_id,
                properties:{
                  "_timestamp":timestamp
                }
              }]
            })
          });

          if (!freeAddResp.ok) {
            console.error('Failed to add free product');
          }
        } catch (err) {
          console.error('Free product fetch error:', err);
        }
      }
      //ak custom code


      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          console.log('res f',response)

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          //this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
